import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
  name: 'dealerTzDate',
  pure: true,
})
export class DealerTzDatePipe implements PipeTransform {
  private dealerTimeZoneToMomentMap: { [id: number]: string } = {
    1: 'America/St_Johns',
    2: 'America/Halifax',
    3: 'America/Atikokan',
    4: 'America/Toronto',
    5: 'America/Regina',
    6: 'America/Winnipeg',
    7: 'America/Edmonton',
    8: 'America/Creston',
    9: 'America/Vancouver',
    10: 'America/Anchorage',
  };

  transform(
    value: string | Date | null | undefined,
    timezoneId: number,
    dstEnabled: boolean,
    format = 'YYYY-MM-DD HH:mm'
  ): string {
    if (!value || !timezoneId) return '';

    const mappedTimeZoneId = this.getMappedDealerTimezoneId(timezoneId, dstEnabled);
    const timezone = this.dealerTimeZoneToMomentMap[mappedTimeZoneId];

    if (!timezone) return '';

    return moment.utc(value).tz(timezone).format(format);
  }

  getMappedDealerTimezoneId(dealerTimezoneId: number, daylightSavingsEnabled: boolean): number {
    //Core removed timezones specific to DST/Non-DST and will always pass in the non-dst timezone
    //So we now map to the correct timezone based on the daylightSavingsEnabled (SCT).
    // 1: 'America/St_Johns', //'Newfoundland Standard Time'
    // 2: 'America/Halifax', //'Atlantic Standard Time'
    // 3: 'America/Atikokan', //'Eastern Standard Time - NO DST'
    // 4: 'America/Toronto', //'US Eastern Standard Time'
    // 5: 'America/Regina', //'Central Standard Time - NO DST'
    // 6: 'America/Winnipeg', //'Canada Central Standard Time'
    // 7: 'America/Edmonton', //'US Mountain Standard Time'
    // 8: 'America/Creston', //'Mountain Standard Time - NO DST'
    // 9: 'America/Vancouver', // 'Pacific Standard Time'
    // 10: 'America/Anchorage', //'Alaskan Standard Time'
    switch (dealerTimezoneId) {
      case 3:
      case 4:
        return daylightSavingsEnabled ? 4 : 3;
      case 5:
      case 6:
        return daylightSavingsEnabled ? 6 : 5;
      case 7:
      case 8:
        return daylightSavingsEnabled ? 7 : 8;
      default:
        return dealerTimezoneId;
    }
  }
}
